export const EmployeeFineEN = {
    "EmployeeFineTitle": {
        "date" : "Date of violation",
        "violationError" : "Violation error",
        "money" : "Money",
        "penaltyForm" : "Penalty form"
    },
    "placeholderFine": {
        "violationError" : "Choose a violation",
        "money" : "1,000,000",
        "penaltyForm" : "Penalty form",
        "Penalized" : "Penalized",
        "employeePaid" : "Employee paid",
        "fromSalary" : "Deduct from salary",
        "who" : "Employees who have not paid fines directly deducted from salary"
    },
    "NotificationEmployeeFine": {
        "edit": "Edit data successfully...",
        "add": "Add data successfully...",
        "delete": "Delete data successfully...",
    }
}